import React, { useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import QuestionbankCM from "../ContentManagement/QuestionbankCM/QuestionbankCM";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const QuestionLibrary = () => {
  const [activeHeader, setActiveHeader] = useState("QuestionBank");
  const [activeSubDeatil, setActiveSubDetail] = useState();
  const [data, setData] = useState();
  const [standard, setStandard] = useState();
  const [standardId, setStandardId] = useState();
  const [section, setSection] = useState();
  const [sectionId, setSectionId] = useState();
  const [supplement, setSupplement] = useState();
  const navigate = useNavigate();
  const [create, setCreate] = useState({
    createContent: "",
    chapterdetail: "",
  });
  let [searchParams, setSearchParams] = useSearchParams({
    header: "",
  });
  const currentHeader = searchParams.get("header");
  const localHeader = localStorage.getItem("ActiveBtn");

  const [openUnsavedDialog, setOpenUnsavedDialog] = useState(false);

  const location = useLocation();
  searchParams = new URLSearchParams(location.header);
  // useEffect(() => {
  //   let btnData = localStorage.getItem("ActiveBtn");
  //   setActiveHeader(btnData)
  // }, [])
  const dataFromLiveSessionDetailPage = (
    data,
    standard,
    section,
    supplementId,
    standardId,
    sectionId
  ) => {
    setData(data);
    setStandard(standard);
    setSection(section);
    setSupplement(supplementId);
    setStandardId(standardId);
    setSectionId(sectionId);
  };

  const savedQuestionBankData = JSON.parse(
    localStorage.getItem("temp_Questions_QUESTION_BANK")
  );

  console.log(savedQuestionBankData, "savedQuestionBankData");

  const checkLocalData = () => {
    if (savedQuestionBankData && savedQuestionBankData !== null) {
      setOpenUnsavedDialog(true);
    } else {
      navigate("/createQuestion");
    }
  };

  const handleContinueSaved = () => {
    setOpenUnsavedDialog(false);
    navigate("/createQuestion");
  };

  const handleCreateNew = () => {
    localStorage.removeItem("temp_Questions_ASSESSMENT");
    localStorage.removeItem("temp_Questions_QUESTION_BANK");
    setOpenUnsavedDialog(false);
    navigate("/createQuestion");
  };

  return (
    <div className="me-3">
      <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap">
        <div className="col-md-4 p-2 five_component_CM ">
          <button
            className={` ${
              activeHeader === "QuestionBank"
                ? " cm_five_active_btn"
                : "cm_five_btn"
            }`}
            onClick={(e) => {
              setActiveHeader("QuestionBank");
              setActiveSubDetail(false);
              setSearchParams({ header: "QuestionBank" });
              setCreate({ chapterdetail: false });
              localStorage.setItem("ActiveBtn", "QuestionBank");
            }}
          >
            My Question Bank
          </button>
          <button
            className={` ${
              activeHeader === "B4SQuestionBank"
                ? " cm_five_active_btn"
                : "cm_five_btn"
            }`}
            onClick={(e) => {
              setActiveHeader("B4SQuestionBank");
              setSearchParams({ header: "B4SQuestionBank" });
              setActiveSubDetail(false);
              setCreate({ chapterdetail: false });
              localStorage.setItem("ActiveBtn", "Library");
            }}
          >
            B4S Question Bank
          </button>
        </div>
      </div>
      <div>
        {activeHeader === "QuestionBank" && (
          <QuestionbankCM
            type="MY_QUESTION_BANK"
            activeHeader={activeHeader}
            checkLocalData={checkLocalData}
          />
        )}
        {activeHeader === "B4SQuestionBank" && (
          <QuestionbankCM type="B4S_QUESTION_BANK" />
        )}
        {/* {create.createContent && <CreateContentCM setCreate={setCreate} />} */}
      </div>

      <Dialog
        open={openUnsavedDialog}
        onClose={() => setOpenUnsavedDialog(false)}
      >
        <DialogTitle>Unsaved Changes Found</DialogTitle>
        <DialogContent>
          <Typography>
            You already have an unsaved question bank –{" "}
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                color: "error.main",
                textDecoration: "underline",
              }}
            >
              {savedQuestionBankData?.questionBankData?.name}
            </Typography>
            . Do you want to continue with it or start a new one?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenUnsavedDialog(false)}
            color="primary"
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={handleContinueSaved}
            color="primary"
            variant="outlined"
          >
            Continue Saved
          </Button>
          <Button onClick={handleCreateNew} color="error" variant="contained">
            Create New
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuestionLibrary;
